module.exports = __webpack_public_path__ + "img/new-comment.f205b9e5.png";